var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMenuCircle = function SvgMenuCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11,
    height: 11,
    fill: "none",
    viewBox: "0 0 11 11"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#menu-circle_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M5.5 11a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M2.956 6.428a.928.928 0 1 0 0-1.856.928.928 0 0 0 0 1.856M5.5 6.428a.928.928 0 1 0 0-1.856.928.928 0 0 0 0 1.856M8.043 6.428a.928.928 0 1 0 0-1.856.928.928 0 0 0 0 1.856"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "menu-circle_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h11v11H0z"
  })))));
};
export default SvgMenuCircle;